export const FilterTypes = {
    Text: `text`,
    Date: `date`,
    Number: `number`,
    Boolean: `boolean`,
    MultiSelect: `multiselect`,
    Custom: `custom`,
    NextMultiSelect: `next-multiselect`
};
export const Operators = {
    $in: `$in`,
    $nin: `$nin`,
    $eq: `$eq`,
    $gt: `$gt`,
    $lt: `$lt`,
    $search: `$search`,
    $notSearch: `$notSearch`,
    $elemMatch: `$elemMatch`,
    $exists: `$exists`,
    $has: `$has`,
    $nhas: `$nhas`,
    $isNull: `$isNull`,
    $notNull: `$notNull`,
    $notEmpty: `$notEmpty`,
    $ne: `$ne`,
    $elemSearch: `$elemSearch`,
    $startsWith: `$startsWith`,
    $endsWith: `$endsWith`,
    $notElemMatch: `$notElemMatch`,
    $notElemSearch: `$notElemSearch`,
    $daysAgo: `$daysAgo`,
    $notDaysAgo: `$notDaysAgo`,
    $daysFromNow: `$daysFromNow`,
    $workingDaysFromNow: `$workingDaysFromNow`,
    $isEmpty: `$isEmpty`
};
export const operatorLabelMap = {
    $in: `Is`,
    $nin: `Is not`,
    $search: `Contains`,
    $notSearch: `Does not contain`,
    $has: `Is`,
    $nhas: `Is not`,
    $exists: `Is`,
    $eq: `Is`,
    $ne: `Is not`,
    $gt: `Is greater than`,
    $lt: `Is less than`,
    $elemMatch: `Is`,
    $isNull: `Is not set`,
    $notNull: `Is set`,
    $notEmpty: `Is`,
    $elemSearch: `Contains`,
    $startsWith: `Starts with`,
    $endsWith: `Ends with`,
    $notElemMatch: `Is not`,
    $notElemSearch: `Does not contain`,
    $daysAgo: `In the last`,
    $notDaysAgo: `Not in the last`,
    $daysFromNow: `In the next`,
    $workingDaysFromNow: `In the next working days`,
    $isEmpty: `Is empty`
};
export const dateOperatorLabelMap = {
    $gt: `Is after`,
    $lt: `Is before`
};
export const getOperatorLabel = (operator, type)=>{
    if (type === FilterTypes.Date) {
        var _dateOperatorLabelMap_operator, _ref;
        return (_ref = (_dateOperatorLabelMap_operator = dateOperatorLabelMap[operator]) != null ? _dateOperatorLabelMap_operator : operatorLabelMap[operator]) != null ? _ref : operator;
    }
    var _operatorLabelMap_operator;
    return (_operatorLabelMap_operator = operatorLabelMap[operator]) != null ? _operatorLabelMap_operator : operator;
};
/**
 * @deprecated Please use getOperatorLabel instead
 */ export const OperatorTypes = {
    $in: {
        default: `Is`
    },
    $nin: {
        default: `Is not`
    },
    $search: {
        default: `Contains`
    },
    $notSearch: {
        default: `Does not contain`
    },
    $has: {
        default: `Is`
    },
    $nhas: {
        default: `Is not`
    },
    $exists: {
        default: `Is`
    },
    $eq: {
        default: `Is`
    },
    $ne: {
        default: `Is not`
    },
    $gt: {
        default: `Is greater than`,
        date: `After`
    },
    $lt: {
        default: `Is less than`,
        date: `Before`
    },
    $elemMatch: {
        default: `Is`
    },
    $isNull: {
        default: `Is not set`
    },
    $notNull: {
        default: `Is set`
    },
    $notEmpty: {
        default: `Is`
    },
    $elemSearch: {
        default: `Contains`
    },
    $startsWith: {
        default: `Starts with`
    },
    $endsWith: {
        default: `Ends with`
    },
    $notElemMatch: {
        default: `Is not`
    },
    $notElemSearch: {
        default: `Does not contain`
    },
    $daysAgo: {
        default: `In the last`
    },
    $notDaysAgo: {
        default: `Not in the last`
    },
    $daysFromNow: {
        default: `In the next`
    },
    $workingDaysFromNow: {
        default: `In the next`
    },
    $isEmpty: {
        default: `Is empty`
    }
};

//# sourceMappingURL=table.js.map